/**
 * WebSocket connection module.
 *
 *  Needs init() call.
 *
 * @version 1
 */
import {
  CONNECTION_OPEN,
  LATENCY_CHECK_REQUESTED,
  MEDIA_STREAM_CANDIDATE_ADD,
  MEDIA_STREAM_INITIALIZED,
  MEDIA_STREAM_SDP_AVAILABLE,
  mEvent,
  PING_REQUEST,
  PING_RESPONSE,
  STREAM_ERROR,
  WEBCAM_STREAM_ANSWER_AVAILABLE,
  WEBCAM_STREAM_CANDIDATE_ADD,
  WEBCAM_STREAM_CANDIDATE_FLUSH,
} from './events.ts'

const socket = (() => {
  const pingIntervalMs = 2000 // 2 secs

  let conn
  let curPacketId = ''
  let pingInterval

  let forceDisconnect = false

  const close = () => {
    forceDisconnect = true
    clearInterval(pingInterval)
    pingInterval = null

    if (conn !== null) {
      conn.close()
      conn = null
    }
  }

  const onWSError = (error) => {
    mEvent.dispatch(STREAM_ERROR, { id: 301, message: error })
  }

  const onWSClosed = () => {
    //
  }

  const init = (url, path, data) => {
    forceDisconnect = false

    const params = new URLSearchParams(data).toString()
    const address = `wss://${url}${path}?${params}`
    conn = new WebSocket(address)

    conn.addEventListener('open', function () {
      pingInterval = setInterval(ping, pingIntervalMs)
      mEvent.dispatch(CONNECTION_OPEN)
      window.conn = conn
    })

    conn.addEventListener('error', function (mEvent) {
      onWSError(mEvent)
    })

    conn.addEventListener('close', function (mEvent) {
      onWSClosed(mEvent)
    })

    conn.addEventListener('message', function (response) {
      const data = JSON.parse(response.data)
      const message = data.id

      switch (message) {
        case 'init':
          let iceservers = JSON.parse(JSON.parse(atob(data.data)))
          mEvent.dispatch(MEDIA_STREAM_INITIALIZED, {
            stunturn: iceservers,
          })
          break
        case 'offer':
          mEvent.dispatch(MEDIA_STREAM_SDP_AVAILABLE, {
            sdp: data.data,
          })
          break
        case 'candidate':
          mEvent.dispatch(MEDIA_STREAM_CANDIDATE_ADD, {
            candidate: data.data,
          })
          break
        /// Webcam init
        case WEBCAM_STREAM_ANSWER_AVAILABLE:
          mEvent.dispatch(WEBCAM_STREAM_ANSWER_AVAILABLE, {
            answer: data.data,
          })
          break
        case WEBCAM_STREAM_CANDIDATE_ADD:
          mEvent.dispatch(WEBCAM_STREAM_CANDIDATE_ADD, {
            candidate: data.data,
          })
          break
        case WEBCAM_STREAM_CANDIDATE_FLUSH:
          mEvent.dispatch(WEBCAM_STREAM_CANDIDATE_FLUSH, {
            candidate: data.data,
          })
          break

        case 'heartbeat':
          mEvent.dispatch(PING_RESPONSE)
          break
        case 'checkLatency':
          curPacketId = data.packet_id
          const addresses = data.data.split(',')
          mEvent.dispatch(LATENCY_CHECK_REQUESTED, {
            packetId: curPacketId,
            addresses: addresses,
          })
          break
        case 'clipboard_text':
          const clipboard = data.data
          if (document.hasFocus()) {
            let paste = decodeUtf8(b64DecodeUnicode(clipboard))
            console.debug('VM to player => ', paste)
            navigator.clipboard?.writeText(paste).catch((error) => {
              console.error(error)
            })
          }
          break
        case 'clipboard_image':
          const image = data.data
          if (document.hasFocus()) {
            copyBase64ImageToClipboard(image)
          }
          break
        default:
          break
      }
    })
  }

  async function copyBase64ImageToClipboard(base64String) {
    try {
      const base64Data = base64String.replace(/^data:image\/png;base64,/, '')
      const byteCharacters = atob(base64Data)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'image/png' })
      const clipboardItem = new ClipboardItem({ 'image/png': blob })
      await navigator.clipboard.write([clipboardItem])
    } catch (error) {
      console.error('Failed to copy image: ', error)
    }
  }

  const b64DecodeUnicode = (str) => {
    try {
      // Check if the input string is a valid Base64-encoded string
      return atob(str)
    } catch (e) {
      // If the input string is not a valid Base64-encoded string,
      // return an empty string
      return ''
    }
  }

  const decodeUtf8 = (incorrectlyEncodedString) => {
    const uint8Array = new Uint8Array(incorrectlyEncodedString.length)
    for (let i = 0; i < incorrectlyEncodedString.length; i++) {
      uint8Array[i] = incorrectlyEncodedString.charCodeAt(i)
    }
    const decoder = new TextDecoder('utf-8')
    return decoder.decode(uint8Array)
  }

  const ping = () => {
    if (!conn || (conn.readyState === 3 && !forceDisconnect)) {
      clearInterval(pingInterval)

      return
    }

    const time = Date.now()
    send({
      id: 'heartbeat',
      data: time.toString(),
    })
    mEvent.dispatch(PING_REQUEST, {
      time: time,
    })
  }

  const send = (data) => {
    if (conn && conn.readyState === 1) {
      conn.send(JSON.stringify(data))
    }
  }

  return {
    init: init,
    close: close,
    send: send,
  }
})(mEvent)

export default socket
